import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { ThemeContext } from '../context/themeContext';
import Toggle from './Toggle';

const Header = ({ onPageClicked }) => {
  const { theme } = React.useContext(ThemeContext);
  const isDarkTheme = theme === 'dark';
  const isCurrentUrlisMovieReviewPage = window.location.pathname === '/top-20-news-articles';
  const isCurrentUrlisAboutPage = window.location.pathname === '/about-author';
  return (
    <header
      className={classNames(
        'body-font fixed -top-0 w-full',
        { 'text-gray-600 bg-white': !isDarkTheme },
        { 'text-gray-400 bg-gray-900': isDarkTheme },
      )}
    >
      <div className='container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center'>
        <a
          href='/'
          className={classNames(
            'flex title-font font-medium items-center mb-4 md:mb-0',
            { 'text-white': isDarkTheme },
            { 'text-gray-900': !isDarkTheme },
          )}
          aria-label='Home Page'
          onClick={onPageClicked.bind(this, '/')}
        >
          <img alt='logo' src='/movie-review.png' width='40px' height='40px' />
          <span className='ml-3 text-xl'>Movie Review Expert</span>
        </a>
        <nav
          className={classNames(
            'md:mr-auto md:ml-4 md:py-1 md:pl-4 md:border-l	flex flex-wrap items-center text-base justify-center',
            { 'md:border-gray-400': !isDarkTheme },
            { 'md:border-gray-700': isDarkTheme },
          )}
        >
          <a
            href='/top-20-news-articles'
            className={classNames(
              'mr-5',
              { 'hover:text-gray-900': !isDarkTheme },
              { 'hover:text-white': isDarkTheme },
              { 'text-gray-900': isCurrentUrlisMovieReviewPage && !isDarkTheme },
              { 'text-white': isCurrentUrlisMovieReviewPage && isDarkTheme },
            )}
            aria-label='Top 20 News Articles'
            onClick={onPageClicked.bind(this, '/top-20-news-articles')}
          >
            Top 20 News Articles
          </a>
          <a
            href='/about-author'
            className={classNames(
              'mr-5',
              { 'hover:text-gray-900': !isDarkTheme },
              { 'hover:text-white': isDarkTheme },
              { 'text-gray-900': isCurrentUrlisAboutPage && !isDarkTheme },
              { 'text-white': isCurrentUrlisAboutPage && isDarkTheme },
            )}
            aria-label='About Author Page'
            onClick={onPageClicked.bind(this, '/about-author')}
          >
            About Author
          </a>
        </nav>
        <Toggle />
      </div>
    </header>
  );
};

Header.propTypes = {
  onPageClicked: PropTypes.func.isRequired,
};

export default Header;
